"use strict";var e;exports.RenderType=void 0,(e=exports.RenderType||(exports.RenderType={})).IMAGE="image",e.CTA="cta";
//# sourceMappingURL=type.js.map
